import React, { useRef, useEffect, useState } from 'react';
import useScrollTop from '../../hooks/useScrollTop';
import useDOMWidth from '../../hooks/useDOMWidth';
import { useLocation } from "react-router-dom";
import '../../styles/main.css';
import { useParams } from 'react-router';
import _, { forEach } from 'lodash';
import icons from '../../utils/icons.json';
import constants from '../../utils/constants.json';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import useCart from '../../hooks/useCart';
import { AnimatePresence, motion } from 'framer-motion';
import { isMobile, removeFromStore, removeHoles } from '../../utils/fn';
import { removeUser } from '../../store/user';
import { setAlert } from '../../store/alert';
import AccountMenu from './accountmenu';
import SignIn from '../Common/login';
import SignUp from '../Common/register';
import Newsletter from './newsletter';
import Adminsignin from '../Admin/login';
import Shopbyconditionbutton from './Menus/shopbycondition';
import fetch from '../../utils/fetch';
import Shopbycategorybutton from './Menus/shopbycategory';
import { TypeAnimation } from 'react-type-animation';

const drawerVariants = {
	initial: {
		left: -300,
	},
	animate: {
		left: 0,
		transition: {
			duration: 0.3,
		},
	},
	exit: {
		left: -300,
		transition: {
			duration: 0.3,
		},
	},
};

const drawerBgVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
		transition: {
			duration: 0.3,
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.3,
		},
	},
};

const categoriesVariant = {
	initial: {
		height: 0,
	},
	animate: {
		height: 'auto',
		transition: {
			duration: 0.3,
		},
	},
	exit: {
		height: 0,
		transition: {
			duration: 0.3,
		},
	},
};

function Header({ }) {
	const navigate = useNavigate()
	const dispatch = useDispatch();
	const location = useLocation()
	const path = location?.pathname?.split("/")[1];

	const [showlogin, setshowlogin] = useState(false);
	const [showsignup, setshowsignup] = useState(false);
	const [shownewletter, setshownewletter] = useState(false);

	const { loggedIn, user } = useSelector((state) => state.user);

	const { top } = useScrollTop(window);
	const { width } = useDOMWidth(window.innerWidth);

	const [searchVisible, setSearchVisible] = useState(false);
	const [drawerVisible, setDrawerVisible] = useState(false);
	const [menuVisible, setMenuVisibility] = useState(false);

	const maxWidth = 750;

	const { category: initCategory, query: initQuery } = useParams();

	const [query, setQuery] = useState(initQuery || '');
	const [category, setCategory] = useState(initCategory || 'ALL');
	const [placeholder, setPlaceholder] = useState('all products');
	const [categoriesVisible, setCategoriesVisible] = useState(false);
	const [conditionsvisible, setconditionsvisible] = useState(false);

	const webSettings = useSelector((state) => state.webSettings.data);
	const categories = useSelector((state) => state.categories.data);
	const cartItems = useSelector((state) => state.cartItems.data);
	const favorites = useSelector((state) => state.favorites.data);


	const [conditions, setconditions] = useState([]);

	const { quantity } = useCart(cartItems);

	useEffect(() => {
		filtercategories()
	}, []);

	useEffect(() => {
		if (category === 'ALL') {
			setPlaceholder('all products');
		} else {
			setPlaceholder(categories[categories.findIndex((ctg) => ctg.item_group === category)].group_name);
		}
	}, [category]);

	useEffect(() => {
		setSearchVisible(width > maxWidth);
	}, [width]);
	const filtercategories = async () => {
		const distinctarray = []
		try {
			const promises = categories.map(async (category) => {
				const res = await fetch.get('getProductsGroup', { group_code: category.item_group });
				const filterlist = res.list?.categories.filter((minicategory) => minicategory?.categoryCode !== 'GEN');
				return filterlist.map((element) => ({ ...element, item_group: category.item_group }));
			});

			const results = await Promise.all(promises);
			const finalconditions = results.flat(); // Combine all results into a single array
			//get distinct
			finalconditions.map((val, key) => {
				const categoryindex = distinctarray.findIndex((obj) => obj.categoryName == val.categoryName)
				if (categoryindex < 0) {
					distinctarray.push(val)
				}
			})
			setconditions(distinctarray);
		} catch (error) {
			// Handle errors here
			console.error('An error occurred:', error);
		}
	};



	function initSearch(e) {
		e.preventDefault();
		navigate(`/search/${category}/${query || '*'}`);
	}

	//on success login
	const successlogin = (path) => {
		setshowlogin(false)
		if (path === 'admin') {
			navigate("/supportdashboard/*")
		} else {
			navigate('/account');
		}
	}

	const onshowlogin = () => {
		setshowlogin(true)
		setshowsignup(false)
	}

	const navigatetoitems = (condition) => {
		setDrawerVisible(false)
		navigate(`/classifications/${condition.categoryName}`, {
			state: {
				classification: condition,
				classifications: conditions
			}
		})
	}


	function groupConditions(conditions, groupSize) {
		const groupedSequence = [];
		for (let i = 0; i < conditions.length; i += groupSize) {
			const group = conditions.slice(i, i + groupSize);
			groupedSequence.push(`Dealers in ${group.map((val) => val.categoryName).join(', ')}`);
			groupedSequence.push(1000);
		}
		return groupedSequence;
	}


	return (
		path !== 'supportdashboard' &&
		<>
			<div className="header-banner">
				{shownewletter && <Newsletter ondismiss={() => setshownewletter(false)} />}
				{showlogin && <SignIn onsuccesslogin={successlogin} ondismiss={() => setshowlogin(false)} />}
				{showsignup && <SignUp successsignup={onshowlogin} onshowlogin={onshowlogin} ondismiss={() => setshowsignup(false)} />}
				<div className="inner">
					<div className="extras">
						{!isMobile() && <div onClick={() => setshownewletter(true)} style={{ cursor: "pointer" }}>Newsletter </div>}
						&nbsp; | &nbsp;
						<div onClick={() => navigate("/about")} style={{ cursor: "pointer" }}>About us</div>  </div>
					{!isMobile() &&
						<div>
							{/* <marquee>Explore {webSettings.FULL_NAME}. Discover a wide range of high-quality products at {webSettings.FULL_NAME?.toLowerCase()}.</marquee> */}
							{webSettings.FULL_NAME && conditions.length > 0 &&
								<TypeAnimation
									sequence={[
										`Explore ${webSettings.FULL_NAME}`,
										1000,
										`Discover a wide range of high-quality products at ${webSettings.FULL_NAME?.toLowerCase()}`,
										1000,
										...groupConditions(conditions, 3), // Group conditions in sets of 4
									]}
									wrapper="span"
									speed={50}
									style={{ display: 'inline-block' }}
									repeat={Infinity}
								/>
							}
						</div>}
					<div className="tel">
						<span>Call or WhatsApp</span>
						<marquee><span style={{ cursor: "pointer" }} onClick={() => window.open(`https://wa.me/${webSettings.TELEPHONES_LINK?.replace(/\s/g, '')}`)}>{removeHoles(webSettings.TELEPHONES_LINK?.replace('+254', '0'))}</span></marquee>
					</div>
				</div>
				{/* <marquee>
					<span>Welcome to {webSettings.FULL_NAME}</span>
					<span>Email: {webSettings.EMAIL_LINK || webSettings.EMAIL_ADDRESS}</span>
					<span>Tel: </span>
					<span>Address: {webSettings.ADDRESS}</span>
					<span>City: {webSettings.CITY}</span>
					<span>Powered by: MaliPlus</span>
				</marquee> */}
			</div>
			<header className="header" style={{ position: top >= 50 ? 'fixed' : 'absolute', top: top >= 50 ? '0px' : '50px' }}>
				<div className="wrapper">
					<div className="inner" style={{}}>
						<div className="section-1 flex">
							{width <= 750 && <button className="menu-btn" onClick={() => setDrawerVisible(true)} dangerouslySetInnerHTML={{ __html: icons.bars }} />}
							<Link to="/">
								<img style={{}} className="logo" src={webSettings && webSettings.WEB_SITE_LOGO} alt="" />
							</Link>
							{searchVisible && (
								<form className="search-form" onSubmit={initSearch}>
									{width <= maxWidth && <button onClick={() => setSearchVisible(false)} className="btn back-btn" type="button" dangerouslySetInnerHTML={{ __html: icons.arrow_left }} />}
									<select value={category} onChange={(e) => setCategory(e.target.value)}>
										<option value="ALL">All Categories</option>
										{categories.map((category, index) => (
											<option key={category.item_group + index} value={category.item_group}>
												{_.startCase(category.group_name)}
											</option>
										))}
									</select>
									<input type="search" placeholder={'Search from ' + placeholder} value={query} onInput={(e) => setQuery(e.target.value)} />
									<button type="submit" dangerouslySetInnerHTML={{ __html: icons.search }} />
								</form>
							)}
						</div>
						<div className="section-2 flex">
							{width <= maxWidth && <button onClick={() => setSearchVisible(true)} className="link" dangerouslySetInnerHTML={{ __html: icons.search }} />}
							<Link className="link" to="/cart" title="Cart" dangerouslySetInnerHTML={{ __html: icons.shopping_cart + (quantity > 0 ? `<span>${quantity}</span>` : '') }} />
							{width > maxWidth && (
								<Link className="link" to="/favorites" dangerouslySetInnerHTML={{ __html: icons.heart + (favorites.length > 0 ? `<span>${favorites.length}</span>` : '') }} title="favorites" />
							)}
							{/* {!loggedIn && <Link className="link" to="/signin" dangerouslySetInnerHTML={{ __html: icons.user }} title="Sign In" />} */}
							<AccountMenu loggedIn={loggedIn} onshowlogin={onshowlogin} onshowsignup={() => setshowsignup(true)} />
							{/* {loggedIn && <p onClick={(e) => setMenuVisibility(!menuVisible)} className="link" to="/signin" dangerouslySetInnerHTML={{ __html: icons.user }} title="My Account" />} */}
							{loggedIn && user && menuVisible && (
								<div onClick={(e) => setMenuVisibility(false)} className="menu">
									<section className="menu-header flex">
										<span dangerouslySetInnerHTML={{ __html: icons.user }}></span>
										<section>
											<h4>{_.startCase(_.lowerCase(user.LEDGER_NAME || user.LEDGER_NUMBER))}</h4>
											{user.CONTACT_PHONE && <p>{user.CONTACT_PHONE}</p>}
										</section>
									</section>
									<p
										onClick={(e) => {
											removeFromStore(constants.USER_PROFILE);
											dispatch(removeUser(''));
											dispatch(setAlert('Logged out successful!'));
										}}
										className="nav-link flex"
										dangerouslySetInnerHTML={{ __html: icons.sign_out + 'Log Out' }}
									></p>
									<Link className="nav-link flex" to="/signin" dangerouslySetInnerHTML={{ __html: icons.sign_in + 'Switch Account' }}></Link>
								</div>
							)}
						</div>
					</div>
				</div>
				<AnimatePresence>
					{width > maxWidth && top < 300 && (
						<motion.nav
							initial={{
								marginTop: -40,
							}}
							animate={{
								marginTop: 0,
								transition: {
									duration: 0.3,
								},
							}}
							exit={{
								marginTop: -40,
								transition: {
									duration: 0.3,
								},
							}}
						>
							<div className="inner">
								<NavLink exact activeClassName="active" className="link" to="/">
									Home
								</NavLink>
								{/* {path && <Shopbycategorybutton />} */}
								<Shopbycategorybutton />
								<Shopbyconditionbutton conditions={conditions} />
								<NavLink exact activeClassName="active" className="link" to="/todays-deals">
									Todays Deals
								</NavLink>
								<NavLink exact className="link" to="/top-selling">
									Best Sellers
								</NavLink>
							</div>
						</motion.nav>
					)}
				</AnimatePresence>
			</header>
			<AnimatePresence>
				{drawerVisible && (
					<div className="navigation-drawer">
						<motion.div variants={drawerBgVariants} initial="initial" animate="animate" exit={drawerBgVariants.exit} onClick={() => setDrawerVisible(false)} className="bg"></motion.div>
						<motion.div variants={drawerVariants} initial="initial" animate="animate" exit={drawerVariants.exit} className="drawer">
							<div className="nav-header">
								<button onClick={() => setDrawerVisible(false)} className="btn back-btn" dangerouslySetInnerHTML={{ __html: icons.arrow_left }} />
								<h4>Menu</h4>
							</div>
							<div className="nav-body">
								<p onClick={() => {
									navigate('/')
									setDrawerVisible(false)
								}} className="link">
									Home
								</p>
								<div>
									<p className="link" onClick={() => setconditionsvisible(!conditionsvisible)}>
										Shop By Brand
										<span dangerouslySetInnerHTML={{ __html: icons.angle_down }} />
									</p>
									<AnimatePresence>
										{conditionsvisible && (
											<motion.div variants={categoriesVariant} exit={categoriesVariant.exit} className="expandable">
												{conditions.map((condition, index) => (
													<p onClick={() => navigatetoitems(condition)} className="link" key={index}>
														{_.startCase(condition.categoryName)}
													</p>
												))}
											</motion.div>
										)}
									</AnimatePresence>
								</div>
								<p onClick={() => {
									setDrawerVisible(false)
									navigate('/todays-deals')
								}} className="link">
									Todays Deals
								</p>
								<p onClick={() => {
									navigate('/top-selling')
									setDrawerVisible(false)
								}} className="link">
									Best Sellers
								</p>
								<div>
									<p className="link" onClick={() => setCategoriesVisible(!categoriesVisible)}>
										Categories
										<span dangerouslySetInnerHTML={{ __html: icons.angle_down }} />
									</p>
									<AnimatePresence>
										{categoriesVisible && (
											<motion.div variants={categoriesVariant} exit={categoriesVariant.exit} className="expandable">
												{categories.map((category, index) => {
													let show = true;
													let len = category.subgroups.length;
													return (
														<div key={category.item_group + index}>
															<p className="link" onClick={() => {
																len > 0 || navigate('/categories/' + category.item_group)
																setDrawerVisible(false)
															}}>
																<b>{_.startCase(category.group_name)}</b>
																{/* {len > 0 && <span dangerouslySetInnerHTML={{ __html: icons.angle_down }} />} */}
															</p>
															{len > 0 && show && (
																<div className="expandable">
																	<p onClick={() => {
																		navigate('/categories/' + category.item_group)
																		setDrawerVisible(false)
																	}} className="link">
																		All
																	</p>
																	{category.subgroups.map((sub_group, index) => (
																		<p
																			onClick={() => {
																				setDrawerVisible(false)
																				navigate('/categories/' + category.item_group + '/' + sub_group.sub_group)
																			}}
																			className="link"
																			key={category.item_group + sub_group.sub_group + index}
																		>
																			{_.startCase(sub_group.sub_group_name)}
																		</p>
																	))}
																</div>
															)}
														</div>
													);
												})}
											</motion.div>
										)}
									</AnimatePresence>
								</div>
								<p onClick={() => {
									navigate('/favorites')
									setDrawerVisible(false)
								}} className="link">
									Favorites
									{favorites.length > 0 && (
										<span>
											<label className="counter">{favorites.length}</label>
										</span>
									)}
								</p>
							</div>
						</motion.div>
					</div>
				)}
			</AnimatePresence>
		</>
	);
}

export default React.memo(Header);
